import { isSeasonalDiscountActive } from "src/data/variables";
import PriceCards from "./hero/cards";
import Title from "./hero/title";

const Hero = () => {
  return (
    <div className="flex flex-col">
      <Title />
      <PriceCards isSeasonalDiscountActive={isSeasonalDiscountActive} />
    </div>
  );
};

export default Hero;
